var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Others = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ width: "37", height: "41" }, props),
        React.createElement("g", null,
            React.createElement("path", { fill: "#00C1B1", opacity: ".4", d: "M25.082 26.383l.227 7.509 1.274 1.498 3.002 3.002h1.501l4.504-3.002v-9.007l-4.504-1.501z" }),
            React.createElement("path", { fill: color, d: "M26.071 27.027v6.316c0 .654.22 1.274.616 1.745.905 1.07 2.247 2.14 4.097 3.264 1.851-1.122 3.194-2.192 4.098-3.263a2.699 2.699 0 0 0 .617-1.745v-6.317l-2.079-.575a9.873 9.873 0 0 0-5.27 0l-2.079.575zm4.713 13.07l-.38-.224c-2.198-1.294-3.789-2.543-4.863-3.817a4.196 4.196 0 0 1-.97-2.712v-7.46l3.18-.878a11.384 11.384 0 0 1 6.068 0l3.181.878v7.46a4.202 4.202 0 0 1-.972 2.712c-1.075 1.276-2.665 2.525-4.863 3.818l-.38.222z" }),
            React.createElement("path", { fill: color, d: "M30.257 33.892l-1.95-1.951 1.061-1.062.889.89 1.945-1.944 1.062 1.06zM30.375 5.053h-3.752V1.3h1.501v2.252h2.251z" }),
            React.createElement("path", { fill: color, d: "M23.058 34.066H6.054V0h22.039l3.443 3.443v19.526h-1.501V4.065l-2.563-2.563H7.555v31.063h15.503z" }),
            React.createElement("path", { fill: color, d: "M9.806 11.777h17.976v-1.501H9.806zM9.806 14.779h17.976v-1.501H9.806zM9.806 17.781h17.976V16.28H9.806zM9.806 20.783h17.976v-1.501H9.806zM9.806 23.785h17.976v-1.501H9.806zM9.806 26.788H22.83v-1.501H9.806zM9.806 29.79H22.83v-1.501H9.806zM9.806 8.775h8.989V7.274H9.806zM1.55 28.52l.705 2.49.796-2.51-.046-25.482-1.5.002.045 25.5zm1.31 5.547H1.558L.05 28.625 0 1.522l4.503-.008.05 27.22-1.693 5.333z" }),
            React.createElement("path", { fill: color, d: "M1.502 2.27L1.498.057 2.999.054l.004 2.213zM.801 29.374l-.003-1.501 3.002-.006.003 1.501z" }),
            React.createElement("path", { fill: color, d: "M1.504 3.02l.004 1.501 1.5-.003-.003-1.5-1.501.002zM.01 6.025L0 1.522l4.504-.009.009 4.504-4.503.008zm1.53 17.343l.003 1.501 1.501-.004-.003-1.5-1.501.003zM.045 26.373L.036 21.87l4.503-.01.009 4.503-4.503.01z" }))));
};
Others.defaultProps = {
    color: '#111',
};
export default Others;
//# sourceMappingURL=Other.js.map